<template>
  <v-col style="max-width: 900px">
    <h1 class="primary--text">
      {{ $t('documentation.texts.clients.title') }}
    </h1>
    <h2 class="primary--text">
      {{ $t('documentation.texts.clients.delete.title') }}
    </h2>
    <p>
      {{ $t('documentation.texts.clients.delete.paragraph1') }}
    </p>
    <v-img style="width: 100%; max-width: 900px" contain :src="pic1Name" />
    <p>
      {{ $t('documentation.texts.clients.delete.paragraph2') }}
    </p>
    <p>
      {{ $t('documentation.texts.clients.delete.paragraph2-1') }}
    </p>
    <v-img style="width: 100%; max-width: 900px" contain :src="pic2Name" />
    <p>
      {{ $t('documentation.texts.clients.delete.paragraph3') }}
    </p>
    <p>
      {{ $t('documentation.texts.clients.delete.paragraph3-1') }}
    </p>
    <v-img style="width: 100%; max-width: 600px" contain :src="pic4Name" />
  </v-col>
</template>

<script>
export default {
  computed: {
    pic1Name() {
      return require('@/assets/documentation/clients/' +
        this.$t('documentation.texts.clients.delete.pic1') +
        '.png')
    },
    pic2Name() {
      return require('@/assets/documentation/clients/' +
        this.$t('documentation.texts.clients.delete.pic2') +
        '.png')
    },
    pic3Name() {
      return require('@/assets/documentation/clients/' +
        this.$t('documentation.texts.clients.delete.pic3') +
        '.png')
    },
    pic4Name() {
      return require('@/assets/documentation/clients/' +
        this.$t('documentation.texts.clients.delete.pic4') +
        '.png')
    },
  },
}
</script>

<style>
.custom-link {
  transition: 0.3s;
  cursor: pointer;
}
.custom-link:hover {
  text-decoration: underline;
}
</style>
